import { InspectionStateInterface } from '../interfaces/inspectionState';

export class InspectionState implements InspectionStateInterface {
    id_inspection_state?: number;
    value: string;

    constructor() {
        this.value = '';
    }
}